import Cookies from 'js-cookie';

function notificationBar() {
    // Cookies and notification bar function for closing it!
    function setCookie(name, value, lifetime_days) {
        var exp = new Date();
        exp.setDate(new Date().getDate() + lifetime_days);
        document.cookie = name + '=' + value + ';expires=' + exp.toUTCString() + ';path=/';
    }

    function getCookie(name) {
        if (document.cookie) {
            var regex = new RegExp(escape(name) + '=([^;]*)', 'gm'),
                matches = regex.exec(document.cookie);
            if (matches) {
                return matches[1];
            }
        }
    }
    jQuery("body").on('click', '.pop-up .close', function () {
        Cookies.set('notify', '1', { expires: 1, path: '' })
        jQuery('.pop-up').addClass('hide');
        setTimeout(function () {
            jQuery('.pop-up').remove();
        }, 2000);
    });
}
notificationBar()

jQuery('.latest-slides').slick({
    fade: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    arrows: false,
    infinite: true,
});

jQuery('.el').readmore({
    speed: 75,
    moreLink: '<a href="#" class="toggle-link">Lees meer</a>',
    lessLink: '<a href="#" class="toggle-link">Toon minder</a>',
    collapsedHeight: 240,
});

jQuery('.logo-slider').slick({
    dots: false,
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  